export default "__VITE_ASSET__0bc2c612__"